export default __webpack_public_path__ + "static/media/decada-0090-0007-min.5450647e.jpg";